<template>
<t-section v-bind:schemaName="'message'" v-bind:fields="fields" v-bind:headers="headers" v-bind:defaultSort="'desc'" v-bind:isHideChart="true" v-bind:isHideButton="true">
        <template v-slot:custom="{ close }">
            <sender-detail v-on:sent="close" />
        </template>
    </t-section>
</template>

<script>
import SenderDetail from "@/views/details/messages/SenderDetail.vue";
    import TSection from '@/components/Sections/SectionV3.vue';
    export default {
        name: "MessageSection",
        components:{
            TSection,
            SenderDetail
        },
        data() {
            return {
                headers:[
                    { field:"createdOn", name: this.$filters.localize('main.createdOn'), class:'message-date-cell', sort:true, router: { field:"id", name:"MessagePage" }},
                    { field:"text", name:"Текст", class:'message-text-cell', sort:true, router: { field:"id", name:"MessagePage" }},
                    { field:"identifier", name:"Ідентифікатор", class:'message-compact-cell', sort:true, filter:true, router: { field:"id", name:"MessagePage" }},
                    { field:"contact.fullName", name:"Контакт", class:'message-compact-cell', sort:true, filter:true, router: { field:"id", name:"MessagePage" }}
                ],
                fields: [
                    { field: "createdOn", name:this.$filters.localize('main.createdOn'), type:"date" },
                    { field: "contact.fullName", name: "Контакт", type:"string" },
                    { field: "text", name: "Текст", type:"string" },
                ]
            }
        }
    }
</script>
